/**
 * Shared styling constants for filter components.
 *
 * All Mantine Select / Popover elements inside the filter popover (z-300)
 * must render their dropdowns above it.  These constants keep that in one
 * place so every filter sub-component stays consistent.
 */

/** Pass as `comboboxProps` to every Mantine <Select> used inside a filter. */
export const FILTER_COMBOBOX_PROPS = {
  withinPortal: true,
  zIndex: 400,
} as const;

/** Mantine `classNames` object for filter selects – matches the design system. */
export const FILTER_SELECT_CLASSES = {
  input:
    "h-7 rounded-md border border-border bg-background px-2 text-[11px] text-foreground",
  dropdown:
    "rounded-md border border-border bg-popover shadow-popover",
  option:
    "text-[11px] text-foreground data-[combobox-selected]:bg-accent data-[combobox-selected]:text-accent-foreground",
} as const;

/** Z-index for Mantine Popover dropdowns inside filters (e.g. StringDropdown). */
export const FILTER_POPOVER_Z_INDEX = 400;
